module.exports = __webpack_public_path__ + "static/media/wd11.50a41589.jpeg";